import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useResolvedAuthenticatedPath } from '../shared/hooks/use-employee-session';

export function AuthenticatedEmployeeRoute() {
  const location = useLocation();
  const redirectPath = useResolvedAuthenticatedPath();

  if (redirectPath === null) {
    return null;
  }

  if (
    redirectPath === '/login' ||
    redirectPath === '/unlock' ||
    (redirectPath === '/settings/pin' &&
      location.pathname !== '/settings/pin') ||
    redirectPath.startsWith('/registration')
  ) {
    return <Navigate replace to={redirectPath} />;
  }

  return <Outlet />;
}
